// src/config/actesConfig.js

// Champs spécifiques par catégorie d'actes
export const champsParCategorie = {
  "VACCIN": [
    { nom: "nomVaccin", label: "Nom du vaccin", type: "text", obligatoire: false },
    { nom: "lot", label: "Numéro de lot", type: "text", obligatoire: false },
    { nom: "dateValidite", label: "Date de validité", type: "date", obligatoire: false }
    // Supprimé le champ rappelJours car géré par la récurrence
  ],
  
  "VERMIFUGE": [
    { nom: "produit", label: "Produit", type: "text", obligatoire: true },
    { nom: "dosage", label: "Dosage", type: "text", obligatoire: false }
    // Supprimé prochainVermifuge car géré par la récurrence
  ],
  
  "MARECHALERIE": [
    { 
      nom: "typeIntervention", 
      label: "Type d'intervention", 
      type: "select",
      obligatoire: true,
      options: [
        "Parage 4 pieds",
        "Parage 2 pieds",
        "Ferrure 4 pieds",
        "Ferrure 2 pieds",
        "Orthopédie fourbure",
        "Orthopédie abcès",
        "Orthopédie seime",
        "Orthopédie encastelure",
        "Orthopédie fourchette",
        "Orthopédie fourmilière",
        "Correction d'aplomb",
        "Fer classique",
        "Fer orthopédique",
        "Fer alu",
        "Fer plastique",
        "Hipposandales"
      ]
    },
    { 
      nom: "membres", 
      label: "Membres concernés", 
      type: "multiselect",
      obligatoire: false,
      options: ["Antérieur gauche", "Antérieur droit", "Postérieur gauche", "Postérieur droit"]
    },
    { nom: "observationsPieds", label: "Observations pieds", type: "textarea", obligatoire: false }
  ],
  
  "OSTÉO / MASSAGE": [
    { nom: "praticien", label: "Praticien", type: "text", obligatoire: false },
    { nom: "dureeSeance", label: "Durée (minutes)", type: "number", obligatoire: false },
    { nom: "zonesTraitees", label: "Zones traitées", type: "textarea", obligatoire: false },
    { nom: "observations", label: "Observations", type: "textarea", obligatoire: false },
    { nom: "exercicesRecommandes", label: "Exercices recommandés", type: "textarea", obligatoire: false }
  ],
  
  "REPRODUCTION": [
    { 
      nom: "typeIntervention", 
      label: "Type d'intervention", 
      type: "select",
      obligatoire: true,
      options: ["Saillie naturelle", "Saillie en main", "IA congelé", "IA frais", "IA réfrigéré", "Transfert embryonnaire"]
    },
    { nom: "etalon", label: "Étalon", type: "text", obligatoire: false },
    { nom: "datePresumePoulinage", label: "Date présumée poulinage", type: "date", obligatoire: false },
    { nom: "resultats", label: "Résultats", type: "textarea", obligatoire: false }
  ],
  
  "TRAITEMENT": [
    { nom: "medicament", label: "Médicament", type: "text", obligatoire: true },
    { nom: "posologie", label: "Posologie", type: "text", obligatoire: true },
    { nom: "dureeJours", label: "Durée (jours)", type: "number", obligatoire: false },
    { 
      nom: "voieAdministration", 
      label: "Voie d'administration", 
      type: "select",
      obligatoire: false,
      options: ["Orale", "Intramusculaire", "Intraveineuse", "Sous-cutanée", "Locale", "Inhalation"]
    }
  ],
  
  "TEST": [
    { 
      nom: "resultat", 
      label: "Résultat", 
      type: "select",
      obligatoire: false,
      options: ["Positif", "Négatif", "En attente", "Non concluant", "Douteux"]
    },
    { nom: "laboratoire", label: "Laboratoire", type: "text", obligatoire: false },
    { nom: "referenceAnalyse", label: "Référence analyse", type: "text", obligatoire: false },
    { nom: "valeurs", label: "Valeurs mesurées", type: "textarea", obligatoire: false }
  ],
  
  "PERFORMANCE": [
    { nom: "lieu", label: "Lieu", type: "text", obligatoire: true },
    { nom: "discipline", label: "Discipline", type: "text", obligatoire: true },
    { nom: "classement", label: "Classement", type: "text", obligatoire: false },
    { nom: "gains", label: "Points/Gains", type: "text", obligatoire: false },
    { nom: "temps", label: "Temps/Chrono", type: "text", obligatoire: false }
  ],
  
  "TRANSPORT": [
    { nom: "destination", label: "Destination", type: "text", obligatoire: true },
    { nom: "transporteur", label: "Transporteur", type: "text", obligatoire: false },
    { nom: "heureDepart", label: "Heure départ", type: "time", obligatoire: false },
    { nom: "heureArrivee", label: "Heure arrivée prévue", type: "time", obligatoire: false },
    { nom: "immatriculation", label: "Immatriculation véhicule", type: "text", obligatoire: false }
  ],
  
  "SOIN": [
    { nom: "zoneConcernee", label: "Zone concernée", type: "text", obligatoire: false },
    { nom: "produitsUtilises", label: "Produits utilisés", type: "textarea", obligatoire: false },
    { nom: "frequence", label: "Fréquence", type: "text", obligatoire: false },
    { nom: "dureeTraitement", label: "Durée du traitement", type: "text", obligatoire: false }
  ],
  
  "ENTRAINEMENT": [
    { nom: "duree", label: "Durée (minutes)", type: "number", obligatoire: false },
    { 
      nom: "intensite", 
      label: "Intensité", 
      type: "select",
      obligatoire: false,
      options: ["Légère", "Modérée", "Intense", "Très intense", "Récupération"]
    },
    { nom: "distance", label: "Distance (km)", type: "number", obligatoire: false },
    { nom: "observationsPerformance", label: "Observations performance", type: "textarea", obligatoire: false }
  ],
  
  "VENTE": [
    { nom: "acheteur", label: "Acheteur", type: "text", obligatoire: true },
    { nom: "prix", label: "Prix de vente", type: "number", obligatoire: false },
    { nom: "commission", label: "Commission", type: "number", obligatoire: false },
    { nom: "dateDepart", label: "Date de départ", type: "date", obligatoire: false },
    { nom: "conditions", label: "Conditions particulières", type: "textarea", obligatoire: false }
  ],
  
  "EVALUATION DE CHEVAUX": [
    { nom: "evaluateur", label: "Évaluateur", type: "text", obligatoire: false },
    { nom: "noteScore", label: "Note/Score", type: "text", obligatoire: false },
    { nom: "pointsForts", label: "Points forts", type: "textarea", obligatoire: false },
    { nom: "pointsAmeliorer", label: "Points à améliorer", type: "textarea", obligatoire: false },
    { nom: "recommandations", label: "Recommandations", type: "textarea", obligatoire: false }
  ],
  
  "ADMINISTRATIF": [
    { nom: "documentType", label: "Type de document", type: "text", obligatoire: true },
    { nom: "numero", label: "Numéro", type: "text", obligatoire: false },
    { nom: "organisme", label: "Organisme", type: "text", obligatoire: false },
    { nom: "dateExpiration", label: "Date d'expiration", type: "date", obligatoire: false }
  ]
};

// Liste complète des actes médicaux
export const listeActesMedicaux = [
  // ADMINISTRATIF
  { typeCategorie: "ADMINISTRATIF", nomActe: "Signalement", couleur: "#6b7280" },
  { typeCategorie: "ADMINISTRATIF", nomActe: "Autre", couleur: "#6b7280" },
  
  // ENTRAINEMENT
  { typeCategorie: "ENTRAINEMENT", nomActe: "Attelage", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Balade", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Cardio", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Cross", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Dressage", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Débourrage", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Endurance", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Liberté", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Longe", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Obstacle", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Plat", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Stretching", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Trotting", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Voltige", couleur: "#8b5cf6" },
  { typeCategorie: "ENTRAINEMENT", nomActe: "Autre", couleur: "#8b5cf6" },
  
  // EVALUATION DE CHEVAUX
  { typeCategorie: "EVALUATION DE CHEVAUX", nomActe: "Cheval de sport", couleur: "#f97316" },
  { typeCategorie: "EVALUATION DE CHEVAUX", nomActe: "Etalon", couleur: "#f97316" },
  { typeCategorie: "EVALUATION DE CHEVAUX", nomActe: "Foal", couleur: "#f97316" },
  { typeCategorie: "EVALUATION DE CHEVAUX", nomActe: "Pesée / Toise", couleur: "#f97316" },
  { typeCategorie: "EVALUATION DE CHEVAUX", nomActe: "Poulinière", couleur: "#f97316" },
  { typeCategorie: "EVALUATION DE CHEVAUX", nomActe: "Poulinière gestante", couleur: "#f97316" },
  { typeCategorie: "EVALUATION DE CHEVAUX", nomActe: "Yearling", couleur: "#f97316" },
  { typeCategorie: "EVALUATION DE CHEVAUX", nomActe: "Autre", couleur: "#f97316" },
  
  // MARECHALERIE
  { typeCategorie: "MARECHALERIE", nomActe: "Maréchalerie", couleur: "#92400e" },
  { typeCategorie: "MARECHALERIE", nomActe: "Parage", couleur: "#92400e" },
  { typeCategorie: "MARECHALERIE", nomActe: "Ferrure", couleur: "#92400e" },
  { typeCategorie: "MARECHALERIE", nomActe: "Orthopédie", couleur: "#92400e" },
  { typeCategorie: "MARECHALERIE", nomActe: "Autre", couleur: "#92400e" },
  
  // OSTÉO / MASSAGE
  { typeCategorie: "OSTÉO / MASSAGE", nomActe: "Séance Ostéo", couleur: "#14b8a6" },
  { typeCategorie: "OSTÉO / MASSAGE", nomActe: "Massage Equin", couleur: "#14b8a6" },
  { typeCategorie: "OSTÉO / MASSAGE", nomActe: "Autre", couleur: "#14b8a6" },
  
  // PERFORMANCE
  { typeCategorie: "PERFORMANCE", nomActe: "Concours", couleur: "#ec4899" },
  { typeCategorie: "PERFORMANCE", nomActe: "Course GALOP", couleur: "#ec4899" },
  { typeCategorie: "PERFORMANCE", nomActe: "Course TROT", couleur: "#ec4899" },
  { typeCategorie: "PERFORMANCE", nomActe: "Autre", couleur: "#ec4899" },
  
  // REPRODUCTION
  { typeCategorie: "REPRODUCTION", nomActe: "Collecte d'embryon", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Collecte de semence", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Constatation d'ovulation", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Diagnostic de gestation", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Déclaration de naissance", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Echographie", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Insémination artificielle en congelé", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Insémination artificielle en frais", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Insémination artificielle en réfrigéré transporté", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Insémination en réfrigéré", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Lavage utérin", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Ponction ovocytaire", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Poulinage", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Saillie en liberté", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Saillie en main", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Sevrage", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Suppression de jumeaux", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Transplantation embryonnaire", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Vulvoplastie", couleur: "#e11d48" },
  { typeCategorie: "REPRODUCTION", nomActe: "Autre", couleur: "#e11d48" },
  
  // SOIN
  { typeCategorie: "SOIN", nomActe: "Balnéothérapie", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Chirurgie", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Dentisterie", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Examen vétérinaire", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Ophtalmologie", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Ostéopathie", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Petite pharmacie", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Suivi de température", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Tonte", couleur: "#06b6d4" },
  { typeCategorie: "SOIN", nomActe: "Autre", couleur: "#06b6d4" },
  
  // TEST
  { typeCategorie: "TEST", nomActe: "Anémie inféctieuse des equidés (AIE)", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Artérite virale équine (AVE) pour jument", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Artérite virale équine (AVE) pour étalon", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Coprologie", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Dermatophilose", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Dourine", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Fièvre de West-Nile", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Gourme", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Leptospirose", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Maladie de Lyme", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Morve", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Métrite contagieuse équine (MEC) pour jument", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Métrite contagieuse équine (MEC) pour étalon", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Piroplasmose", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Rhinopneumonie", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Salmonellose", couleur: "#9333ea" },
  { typeCategorie: "TEST", nomActe: "Autre", couleur: "#9333ea" },
  
  // TRAITEMENT
  { typeCategorie: "TRAITEMENT", nomActe: "Pathologies ostéo-articulaires", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Anesthésie locale", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Anti-infectieux", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Anti-inflammatoire", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Anti-mycosique", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Anti-parasitaire", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Induction de l'ovulation", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Induction du poulinage - OCYTOCINE", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Injectable antispasmodique et antalgique", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Progestagène - REGUMATE®", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Progestérone - Spirale vaginale", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Prostaglandine - PROSOLVIN®", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Sédatif et analgésique", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Troubles digestifs", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Troubles respiratoires", couleur: "#2563eb" },
  { typeCategorie: "TRAITEMENT", nomActe: "Autre", couleur: "#2563eb" },
  
  // TRANSPORT
  { typeCategorie: "TRANSPORT", nomActe: "Concours", couleur: "#059669" },
  { typeCategorie: "TRANSPORT", nomActe: "Hippodrome", couleur: "#059669" },
  { typeCategorie: "TRANSPORT", nomActe: "Loisir", couleur: "#059669" },
  { typeCategorie: "TRANSPORT", nomActe: "Vétérinaire", couleur: "#059669" },
  { typeCategorie: "TRANSPORT", nomActe: "Autre", couleur: "#059669" },
  
  // VACCIN
  { typeCategorie: "VACCIN", nomActe: "Artérite virale", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Fièvre de West Nile", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Gourme", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Grippe", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Grippe - Rhino", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Grippe - Tétanos", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Rage", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Rhinopneumonie", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Rotavirose", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Tétanos", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Tétanos - Grippe - Rhino", couleur: "#22c55e" },
  { typeCategorie: "VACCIN", nomActe: "Autre", couleur: "#22c55e" },
  
  // VENTE
  { typeCategorie: "VENTE", nomActe: "Vente Agence", couleur: "#dc2626" },
  { typeCategorie: "VENTE", nomActe: "Autre", couleur: "#dc2626" },
  
  // VERMIFUGE
  { typeCategorie: "VERMIFUGE", nomActe: "Vermifuge sonde", couleur: "#eab308" },
  { typeCategorie: "VERMIFUGE", nomActe: "Vermifuges", couleur: "#eab308" },
  { typeCategorie: "VERMIFUGE", nomActe: "Autre", couleur: "#eab308" }
];

// Fonction pour initialiser les types d'actes dans Firebase
export const initializeTypesActes = async (db, setDoc, doc, collection) => {
  console.log('Initialisation des types d\'actes...');
  
  let ordre = 1;
  const promises = [];
  
  for (const acte of listeActesMedicaux) {
    const docRef = doc(collection(db, "typesActes"));
    const acteData = {
      id: docRef.id,
      typeCategorie: acte.typeCategorie,
      nomActe: acte.nomActe,
      couleur: acte.couleur,
      actif: true,
      ordre: ordre++,
      champsSpecifiques: champsParCategorie[acte.typeCategorie] || [],
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    
    promises.push(setDoc(docRef, acteData));
  }
  
  await Promise.all(promises);
  console.log(`${listeActesMedicaux.length} types d'actes initialisés avec succès`);
};

// Couleurs par défaut pour les catégories
export const couleursCategories = {
  "ADMINISTRATIF": "#6b7280",
  "ENTRAINEMENT": "#8b5cf6",
  "EVALUATION DE CHEVAUX": "#f97316",
  "MARECHALERIE": "#92400e",
  "OSTÉO / MASSAGE": "#14b8a6",
  "PERFORMANCE": "#ec4899",
  "REPRODUCTION": "#e11d48",
  "SOIN": "#06b6d4",
  "TEST": "#9333ea",
  "TRAITEMENT": "#2563eb",
  "TRANSPORT": "#059669",
  "VACCIN": "#22c55e",
  "VENTE": "#dc2626",
  "VERMIFUGE": "#eab308"
};

// Types de récurrence disponibles
export const typesRecurrence = [
  { value: "mensuelle", label: "Mensuelle" },
  { value: "trimestrielle", label: "Trimestrielle" },
  { value: "semestrielle", label: "Semestrielle" },
  { value: "annuelle", label: "Annuelle" }
];

// Statuts possibles pour un acte
export const statutsActe = [
  { value: "planifie", label: "Planifié", color: "blue" },
  { value: "realise", label: "Réalisé", color: "green" },
  { value: "annule", label: "Annulé", color: "red" },
  { value: "reporte", label: "Reporté", color: "orange" }
];

// Types d'intervenants
export const typesIntervenants = [
  "Vétérinaire",
  "Maréchal-ferrant",
  "Ostéopathe",
  "Dentiste équin",
  "Comportementaliste",
  "Nutritionniste",
  "Kinésithérapeute",
  "Shiatsu",
  "Magnétiseur",
  "Moniteur d'équitation",
  "Cavalier professionnel",
  "Transporteur",
  "Autre"
];

// Fonction utilitaire pour obtenir les rappels à venir
export const getRappelsAVenir = (actes, joursAvance = 30) => {
  const aujourd = new Date();
  const dateLimite = new Date();
  dateLimite.setDate(dateLimite.getDate() + joursAvance);
  
  return actes.filter(acte => {
    if (!acte.recurrence?.active || !acte.recurrence?.prochaineEcheance) {
      return false;
    }
    
    const dateEcheance = new Date(acte.recurrence.prochaineEcheance);
    const dateRappel = new Date(dateEcheance);
    dateRappel.setDate(dateRappel.getDate() - (acte.recurrence.rappelJoursAvant || 30));
    
    return dateRappel >= aujourd && dateRappel <= dateLimite;
  });
};

// Fonction pour calculer la prochaine échéance selon le type de récurrence
export const calculerProchaineEcheance = (dateActuelle, typeRecurrence) => {
  const date = new Date(dateActuelle);
  
  switch (typeRecurrence) {
    case "mensuelle":
      date.setMonth(date.getMonth() + 1);
      break;
    case "trimestrielle":
      date.setMonth(date.getMonth() + 3);
      break;
    case "semestrielle":
      date.setMonth(date.getMonth() + 6);
      break;
    case "annuelle":
      date.setFullYear(date.getFullYear() + 1);
      break;
    default:
      return null;
  }
  
  return date.toISOString().split('T')[0];
};

// Export par défaut
export default {
  champsParCategorie,
  listeActesMedicaux,
  couleursCategories,
  typesRecurrence,
  statutsActe,
  typesIntervenants,
  initializeTypesActes,
  getRappelsAVenir,
  calculerProchaineEcheance
};